export class HttpError extends Error {
    constructor(public status: number, message: string) { super(message); }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
    const res = await fetch(path, { ...init, credentials: 'include' });
    if (res.status === 401) {
        throw new HttpError(401, 'Login required');
    }
    if (!res.ok) {
        const text = await res.text();
        throw new HttpError(res.status, text || res.statusText);
    }
    return res.json() as Promise<T>;
}
